(function() {
'use strict';

angular
    .module('TR')
    .controller('FlightType', FlightType);

function FlightType($scope, searchUnitService, $location, $route) {
    const cm = this;

    cm.flightTypes = searchUnitService.getFlightTypes();
    cm.selected = { flightType: searchUnitService.getFlightType() };

    $scope.$on('radio-clicked', function() {
        searchUnitService.setFlightType(cm.selected.flightType);
        $location.path($route.current.area);
    });
}
})();
